import axios from "axios";

const SaveCustomerCartIdToMetafield = async (cartId, customerId) => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_SHOPIFY_PROXY_URL}/api/graphql`,
      method: "POST",
      data: {
        query: `
          mutation {
            metafieldsSet(
              metafields: [
                {
                  ownerId: "${customerId}",
                  namespace: "cart",
                  key: "last_cart_id",
                  value: "${cartId}",
                  type: "single_line_text_field"
                }
              ]
            ) {
              metafields {
                key
                namespace
                value
              }
              userErrors {
                field
                message
              }
            }
          }
        `,
      },
    });

    const result = response.data?.body?.data?.metafieldsSet;
    if (result?.metafields?.length) {
      return true;
    } else {
      console.warn("Metafield save error", result?.userErrors);
      return false;
    }
  } catch (err) {
    console.error("Failed to save cartId via proxy", err);
    return false;
  }
};

export default SaveCustomerCartIdToMetafield;
